import React, { Component } from 'react';

class UtilityModal extends Component {

    render() {
        if (!this.props.modal)return null;
        return [
            <div key="utility-modal-content" className={"utility-modal modal fade " + (this.props.modal?'show':'')} tabIndex="-1" role="dialog" aria-hidden="true">
                <div className={"modal-dialog " + this.props.modal.className} role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title text-green">{this.props.modal.title}</h5>
                            { !this.props.modal.onDone || this.props.modal.forceClose ? 
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => {
                                    this.props.hideModal();
                                }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            : null }
                        </div>
                        <div className="modal-body">
                            {this.props.modal.content}
                            {this.props.modal.modalImage ? <div style={{textAlign: "center", marginTop: "10px"}}><img alt="recession graph" src={this.props.modal.modalImage} /></div> : null }
                        </div>
                        { !this.props.modal.footer ?
                            <div className="modal-footer">
                                { this.props.modal.onDone ? 
                                    <button type="button" className="btn btn-sm btn-success" style={{ minWidth: '100px', padding: '4px 10px' }} data-dismiss="modal" onClick={() => {
                                        if (this.props.modal.onDone())this.props.hideModal();       
                                    }}>{ this.props.modal.doneText || 'Done' }</button>    
                                : 
                                    <button type="button" className="btn btn-sm btn-success" style={{ minWidth: '100px', padding: '4px 10px' }} data-dismiss="modal" onClick={() => {
                                        this.props.hideModal();
                                    }}>Close</button>
                                }
                            </div>
                            : null
                        }
                        {this.props.modal.footer ?
                            <div className="modal-footer">{this.props.modal.footer}</div>
                        : null }
                    </div>
                </div>
            </div>,
            <div key="utility-modal-backdrop" className={"utility-modal modal-backdrop fade " + (this.props.modal?'show':'')}></div>
        ];
    }
}

export default UtilityModal;
